
module.exports = {

	default: { click: { dest: 'customer', elem: 'page', act: 'show', id: `customer-page`, leftnav: 'leftnav-sale-page'}, },

	//-------------------------------------------------------------------------------------------------------------------------------------
	purchase: {
		mainPage: true,
		activePage: '',
		click: { dest: 'purchase', elem: 'page', act: 'show', id: `purchase-page`, leftnav: 'leftnav-purchase-page', from: 'leftnav' },
	},
	provider: {
		mainPage: false,
		parentPage: 'purchase',
		click: { dest: 'provider', elem: 'page', act: 'show', id: `provider-page`, leftnav: 'leftnav-purchase-page', },
	},
	providercredit: {
		mainPage: false,
		parentPage: 'purchase',
		click: { dest: 'providercredit', elem: 'page', act: 'show', id: `providercredit-page`, leftnav: 'leftnav-purchase-page', },
	},
	providerProfit: {
		mainPage: false,
		parentPage: 'purchase',
		click: { dest: 'providerProfit', elem: 'page', act: 'show', id: `providerProfit-page`, leftnav: 'leftnav-purchase-page' },
	},
	accountsPayable: {
		mainPage: false,
		parentPage: 'purchase',
		click: { dest: 'accountsPayable', elem: 'page', act: 'show', id: `accountsPayable-page`, leftnav: 'leftnav-purchase-page' },
	},
	sentpayment: {
		mainPage: false,
		parentPage: 'purchase',
		click: { dest: 'sentpayment', elem: 'page', act: 'show', id: `sentpayment-page`, leftnav: 'leftnav-purchase-page', },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------	
	purchaseDeleted: {
		mainPage: true,
		activePage: '',
		click: { dest: 'purchaseDeleted', elem: 'page', act: 'show', id: `purchaseDeleted-page`, leftnav: 'leftnav-purchaseDeleted-page', from: 'leftnav' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	sale: {
		mainPage: true,
		activePage: '',
		click: { dest: 'sale', elem: 'page', act: 'show', id: 'sale-page', leftnav: 'leftnav-sale-page', from: 'leftnav' },
	},
	retail: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'retail', elem: 'page', act: 'show', id: 'retail-page', leftnav: 'leftnav-sale-page' },
	},
	retailDeleted: {
		mainPage: false,
		parentPage: 'retail',
		click: { dest: 'retailDeleted', elem: 'page', act: 'show', id: 'retailDeleted-page', leftnav: 'leftnav-sale-page' },
	},
	customer: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'customer', elem: 'page', act: 'show', id: 'customer-page', leftnav: 'leftnav-sale-page' },
	},
	customercredit: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'customercredit', elem: 'page', act: 'show', id: 'customercredit-page', leftnav: 'leftnav-sale-page' },
	},
	customerProfit: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'customerProfit', elem: 'page', act: 'show', id: 'customerProfit-page', leftnav: 'leftnav-sale-page' },
	},
	accountsReceivable: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'accountsReceivable', elem: 'page', act: 'show', id: 'accountsReceivable-page', leftnav: 'leftnav-sale-page' },
	},
	receivepayment: {
		mainPage: false,
		parentPage: 'sale',
		click: { dest: 'receivepayment', elem: 'page', act: 'show', id: 'receivepayment-page', leftnav: 'leftnav-sale-page' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	saleDeleted: {
		mainPage: true,
		activePage: '',
		click: { dest: 'saleDeleted', elem: 'page', act: 'show', id: `saleDeleted-page`, leftnav: 'leftnav-saleDeleted-page', from: 'leftnav' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	item: {
		mainPage: true,
		activePage: '',
		click: { dest: 'item', elem: 'page', act: 'show', id: `item-page`, leftnav: 'leftnav-item-page', from: 'leftnav' },
	},
	areas: {
		mainPage: false,
		parentPage: 'item',
		click: { dest: 'areas', elem: 'page', act: 'show', id: `areas-page`, leftnav: 'leftnav-item-page', },
	},
	item_unit: {
		mainPage: false,
		parentPage: 'item',
		click: { dest: 'item_unit', elem: 'page', act: 'show', id: `item_unit-page`, leftnav: 'leftnav-item-page', },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	transaction: {
		mainPage: true,
		activePage: '',
		click: { dest: 'transaction', elem: 'page', act: 'show', id: `transaction-page`, leftnav: 'leftnav-transaction-page', from: 'leftnav' },
	},
	accounts: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'accounts', elem: 'page', act: 'show', id: `accounts-page`, leftnav: 'leftnav-transaction-page' },
	},
	accountreconciliation: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'accountreconciliation', elem: 'page', act: 'show', id: 'accountreconciliation-page', leftnav: 'leftnav-transaction-page' },
	},
	otherexpense: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'otherexpense', elem: 'page', act: 'show', id: `otherexpense-page`, leftnav: 'leftnav-transaction-page' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	dashboard: {
		mainPage: true,
		activePage: '',
		click: { dest: 'dashboard', elem: 'page', act: 'show', id: `dashboard-page`, leftnav: 'leftnav-dashboard-page', from: 'leftnav' },
	},

	suggestion: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'suggestion', elem: 'page', act: 'show', id: `suggestion-page`, leftnav: 'leftnav-dashboard-page' },
	},
	emailTracking: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'emailTracking', elem: 'page', act: 'show', id: `emailTracking-page`, leftnav: 'leftnav-dashboard-page' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	admin: {
		mainPage: true,
		activePage: '',
		click: { dest: 'admin', elem: 'page', act: 'show', id: `admin-page`, leftnav: '' },
	},
 
	report: {
		mainPage: true,
		activePage: '',
		click: { dest: 'report', elem: 'page', act: 'show', id: `report-page`, leftnav: '' },
	},

	users: {
		mainPage: true,
		activePage: '',
		click: { dest: 'users', elem: 'page', act: 'show', id: `users-page`, leftnav: '' },
	},

	employesspayment: {
		mainPage: true,
		activePage: '',
		click: { dest: 'employesspayment', elem: 'page', act: 'show', id: `employesspayment-page`, leftnav: '' },
	},

}
